import * as resolvers from 'app/infrastructure/ui/renderer/resolvers';
import { ComponentDescriptor } from 'app/infrastructure/ui/types-uischema';

export const childValues = (caseState, uiEngineProps) => {
  const descriptor: ComponentDescriptor = uiEngineProps.componentDescriptor;
  const values =
    descriptor && descriptor.children &&
    descriptor.children
      .filter(child => child.dataTag) // Only children that has a dataTag
      .map(child =>
        resolvers.getComponentValues(caseState, uiEngineProps, child.dataTag)
      );

  return {
    childValues: values
  };
};
